var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 34,
    viewBox: "0 0 24 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 17C24 16.1553 23.5026 15.3106 23.0052 14.8882L6.59068 0.950311C5.09845 -0.316769 2.6114 -0.316769 1.11917 0.950312C-0.373058 2.21739 -0.373058 4.32919 1.11917 5.59627L14.5492 17L1.11917 28.4037C-0.373057 29.6708 -0.373057 31.7826 1.11917 33.0497C2.6114 34.3168 5.09845 34.3168 6.59068 33.0497L22.5078 19.5342C23.5026 18.6894 24 17.8447 24 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.7cb6d22fa004b570b8262af8d7409e6e.svg";
export { ForwardRef as ReactComponent };